import React from 'react';
import { styled } from '@linaria/react';
import { useTheme, ITheme } from 'src/theme';

const List = styled.ul`
  list-style: none;
  display: flex;
  padding: 0;
  flex-wrap: wrap;
  margin: 0;
  margin-bottom: 10px;
  flex-wrap: wrap;
  li {
    line-height: 2.75;
    margin-bottom: 5px;
    &: nth-child(odd) {
      width: 40%;
      @media screen and (max-width: 768px) {
        width: unset;
        min-width: 40%;
      }
     
    }
    &: nth-child(even) {
      width: 60%;
    }
  }

  .copyright-inline {
    display: none;
  }  

  @media screen and (min-width: 768px) {
    display: flex;
    flex-wrap: nowrap;
    margin-bottom: 15px;
    li { 
      width: auto !important;
      margin-right: 30px; 
    }
  }
  @media screen and (min-width: 1280px) {
    justify-content: space-between;
    li { margin: 0; }
    margin: 0;
    .copyright-inline {
      display: inline-flex;
      align-items: center;
    }  
  }
`

const CTA = styled.a<FooterProps>`
  color: ${props => props.theme?.colors.grey[700]};
  font-size: ${props => props.theme?.fontSize.text || 0}px;
  text-decoration: none;
  line-height: 2.75;
  font-family: ${props => props.theme?.fontFamily + ''};
`

const CopyrightText = styled.span<FooterProps>`
  color: ${props => props.theme?.colors.grey[700]};
  font-size: ${props => props.theme?.fontSize.description || 0}px;
  font-family: ${props => props.theme?.fontFamily + ''};
  line-height: 1.71;
  letter-spacing: normal;
  @media screen and (min-width: 768px) {
    font-size: ${props => props.theme?.fontSize.text || 0}px;
    line-height: 2.75;
  }
`

const Container = styled.footer<FooterProps>`
  background-color: ${props => props.theme?.colors.grey[800]};
  padding: 30px 0 30px 0;
  margin-top: 40px;
`

const Grid = styled.div<{ theme: ITheme }>`
  display: block;
  margin: 0 auto;
  max-width: 1230px;
  padding: 0 25px;
  @media screen and (min-width: 1280px) {
    .copyright {
      display: none;
    }  
  }
`

interface Reference { text: string, url: string }

export interface FooterProps {
  references?: Reference[];
  theme?: ITheme;
  copyright?: string;
}

function Footer({ references, copyright }: FooterProps) {
  const theme: ITheme = useTheme();
  // const [isFixed, setIsFixed] = useState<boolean>(false);
  // useEffect(() => {
  //   const handleResize = (type: string) => (e: any) => {
  //     const root: any = document.getElementById('root');
  //     if (e && root && root.clientHeight) {
  //       const windowHeight = type === 'load' ? e.currentTarget.innerHeight : e.target.innerHeight;
  //       const shouldBeFixed = windowHeight > root.clientHeight;
  //       setIsFixed(shouldBeFixed);
  //     }
  //   }
  //   window.addEventListener('load', handleResize('load'));
  //   window.addEventListener('resize', handleResize('resize'));
  // }, []);

  const renderReferences = (list: Reference[] | undefined) => {
    if (!list) { return }
    return (<List>
      {
        list.map((item: Reference, index: number) => (<li key={`reference-${index}`} >
          <CTA target="_blank" rel="noopener noreferrer" theme={theme} href={item.url}> {item.text} </CTA>
        </li>))
      }
      <li className="copyright-inline">
      <CopyrightText theme={theme}> &copy; {copyright} </CopyrightText>
      </li>
    </List>);
  }
  //className={isFixed ? fixedFooter : ''}
  return <Container theme={theme}> 
    <Grid theme={theme}>
      {renderReferences(references)}
      <CopyrightText className="copyright" theme={theme}> &copy; {copyright} </CopyrightText>
    </Grid>
  </Container>
};

export default Footer;
